export default __webpack_public_path__ + "static/media/backer-fera-strategies.90f53221.png";